/**
 * Owner for Ontario HRS claim-step outbound CTAs. Listens on the host
 * (not document) and fires sendGaEvent from data-ga-event stamped in Liquid.
 */

import { getActiveCurrency, sendGaEvent } from "@theme/ga-events";

class ClaimStepCta extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#onClick);
  }

  #onClick = () => {
    const name = this.dataset.gaEvent;
    if (!name) return;

    const link = this.querySelector("a");
    const programHandle = this.dataset.programHandle;
    if (!programHandle) return;

    sendGaEvent(name, {
      page_path: window.location.pathname,
      cta_label: link?.textContent?.trim() || "",
      cta_href: link?.href || "",
      program_handle: programHandle,
      value: 1,
      currency: getActiveCurrency(),
    });
  };
}

if (!customElements.get("claim-step-cta")) {
  customElements.define("claim-step-cta", ClaimStepCta);
}
